import { render, staticRenderFns } from "./KnivesetsFilters.vue?vue&type=template&id=7e246774&"
import script from "./KnivesetsFilters.vue?vue&type=script&lang=ts&"
export * from "./KnivesetsFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports